import { createSlice } from "@reduxjs/toolkit";
const activitySlice = createSlice({
  name: "activityQuestions",
  initialState: {
    activityDetials: [],
    loading: false,
    error: null,
  },
  reducers: {
    setActivityQuestions(state, action) {
      state.activityDetials = action.payload;
    },
  },
});

export const { setActivityQuestions } = activitySlice.actions;

export default activitySlice.reducer;
